import React, { useContext } from 'react'

import { Container, UserContext } from '@doist/marketist'

import { Footer, Navbar, Seo } from 'components'
import * as Sections from 'components/IntegrationsPage/IndividualPage'
import { GetServerSidePropsContext } from 'next'
import { useTranslation } from 'next-i18next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { getCommonServerSideProps } from 'services'
import { IntegrationsClient as contentful } from 'services/contentful'
import { getOgImageURL } from 'services/ogimage'
import { Integration as IntegrationType } from 'types/contentful'

import css from './app.module.css'

export default function Integration({ integration }: { integration: IntegrationType }) {
    const utm_campaign = 'integrations'
    const { t, i18n } = useTranslation('integrations')
    const { isAuthenticated } = useContext(UserContext)
    const ogimage = getOgImageURL('og-image-integrations.jpg', i18n.language)
    const ogimages = [{ url: ogimage, width: 1200, height: 628, alt: t('seoImageAlt') }]
    const {
        slug,
        name,
        commonContent: { tagline },
    } = integration

    return (
        <>
            <Seo
                path={`/integrations/apps/${slug}`}
                title={t('appSeoTitle', { name })}
                description={tagline}
                lang={i18n.language}
                images={ogimages}
            />
            <Navbar isAuth={isAuthenticated} />
            <Sections.IntegrationAppHeader integration={integration} />
            <Container className={css.infoBody}>
                <Sections.IntegrationAppAsideInfo integration={integration} />
                <Sections.IntegrationAppDetails integration={integration} />
            </Container>
            <Sections.IntegrationAppPremiumCTA />
            <Footer utm_campaign={utm_campaign} />
        </>
    )
}

export async function getServerSideProps(ctx: GetServerSidePropsContext) {
    const { query } = ctx

    const { locale, ...commonProps } = await getCommonServerSideProps(ctx)

    let integration = await contentful.getCustomIntegrationBySlug(
        query.integration as string,
        locale,
    )

    if (!integration) {
        integration = await contentful.getZapierIntegrationBySlug(
            query.integration as string,
            locale,
        )

        if (!integration) {
            return {
                notFound: true,
            }
        }
    }

    return {
        props: {
            integration,
            ...commonProps,
            ...(await serverSideTranslations(locale, ['common', 'integrations'])),
        },
    }
}
